/* INTEGY V632 — cart policy acknowledgement owner.
   Keeps exactly one policy acknowledgement on /cart even if a legacy/app script injects
   another notice next to Empire's secondary cart-title checkout button. */
(function () {
  'use strict';
  var PHRASE = 'i have read, understand, and agree to the';
  var scheduled = false;

  function normalized(el) {
    return String(el && el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function owner() {
    return document.querySelector('[data-integy-v632-policy-owner]');
  }

  function isCandidate(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.hasAttribute('data-integy-v632-policy-owner')) return false;
    var text = normalized(el);
    if (text.indexOf(PHRASE) === -1 || text.length > 420) return false;
    /* Remove the smallest matching wrapper, never a large cart/layout ancestor. */
    var childMatch = Array.prototype.some.call(el.children || [], function (child) {
      return normalized(child).indexOf(PHRASE) !== -1;
    });
    return !childMatch;
  }

  function clean() {
    scheduled = false;
    if (!document.body || !document.body.classList.contains('template-cart')) return;
    var canonical = owner();
    if (!canonical) return;

    document.querySelectorAll('p,div,span,label').forEach(function (el) {
      if (!isCandidate(el)) return;
      /* Canonical notice owns this text; every other compact copy is redundant. */
      if (!canonical.contains(el)) {
        el.setAttribute('data-integy-policy-duplicate', 'true');
        el.remove();
      }
    });
  }

  function queue() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(clean);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clean, { once: true });
  } else {
    clean();
  }

  var root = document.querySelector('main') || document.body;
  if (root && window.MutationObserver) {
    new MutationObserver(queue).observe(root, { childList: true, subtree: true });
  }
})();
